import InfoLine from "@/assets/icons/InfoLine";
import { Heading } from "@/components/ui/heading";
import { HStack } from "@/components/ui/hstack";
import { Pressable } from "@/components/ui/pressable";
import { Skeleton, SkeletonText } from "@/components/ui/skeleton";
import { useT } from "@transifex/react";

interface GarageHeaderProps {
  locationName: string | undefined;
  onInfoPress: () => void;
}

export const GarageHeader: React.FC<GarageHeaderProps> = ({ locationName, onInfoPress }) => {
  const t = useT();

  return (
    <HStack className="justify-center items-center gap-[8]">
      <Heading className="text-lg font-bold leading-[24.2px]text-typography-900 text-center"> {locationName && t(locationName)}</Heading>
      <Pressable onPress={onInfoPress}>
        <InfoLine stroke="bg-typography-900" fill="none" />
      </Pressable>
    </HStack>
  );
};

export const GarageHeaderSkeleton = () => (
  <HStack className="justify-center items-center gap-[8]">
    <SkeletonText className="h-[30px] w-[150px] rounded-md" />
    <Skeleton variant="circular" className="h-[20px] w-[20px]" />
  </HStack>
);
